import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TableDescription } from '@mwe/models';
import { NgClass } from '@angular/common';
import { InfoTextComponent } from '../info-text/info-text.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mwe-table-striped',
  templateUrl: './table-striped.component.html',
  imports: [NgClass, InfoTextComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableStripedComponent {
  readonly description = input<TableDescription>(undefined);
  readonly cellClasses = input<string[]>([]);
  readonly classes = input<string[]>([]);
  // accessing ng-content via contentChild with "slot" doesn't seem to be possible so this is the alternative solution
  readonly summary = input<boolean>(false);
}
